// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .question-wrapper[data-v-bdb530d4]{border-top:.7px solid #e2e7e9}[dir] .question-wrapper[data-v-bdb530d4]:last-child{border-bottom:.7px solid #e2e7e9}[dir] .sharp-btn[data-v-bdb530d4]{border-radius:0}[dir] .question-spacing[data-v-bdb530d4]{padding:12px 0}.number-input[data-v-bdb530d4]{width:80px}", ""]);
// Exports
module.exports = exports;
